module.exports = __webpack_public_path__ + "img/prjBoard.4415393a.svg";